import React from 'react'
import NavbarComp from "./components/NavbarComp.js";

export default function Explore() {
    return (
        <div>
            <NavbarComp/>
            <div className='verge'>
            <iframe title="Testing" width="2024" height="1640" allowfullscreen src="https://v3d.net/17q"></iframe>
            </div>
        </div>
    )
}
